import { Link } from "react-router-dom";
import type { Topic } from "@/types/video";

interface TopicGridProps {
  topics: Topic[];
}

export default function TopicGrid({ topics }: TopicGridProps) {
  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
      {topics.map((topic) => (
        <Link
          key={topic.id}
          to={`/search?q=${encodeURIComponent(topic.keyword)}`}
          className="group relative overflow-hidden rounded-lg border border-background-200 bg-background-50 cursor-pointer"
        >
          <div className="relative h-36 w-full overflow-hidden">
            <img
              src={topic.cover}
              alt={`${topic.name} 专题封面`}
              title={`${topic.name} - 黑料视频专题`}
              className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
            <span className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-foreground-950/25 to-transparent"></span>
            <span className="absolute bottom-3 left-3 rounded-full bg-accent-500 px-2.5 py-0.5 text-xs font-medium text-background-50">
              专题
            </span>
            <h3 className="absolute bottom-3 right-3 font-heading text-base font-black text-background-50">
              {topic.name}
            </h3>
          </div>
          <div className="p-4">
            <p className="line-clamp-2 text-xs leading-relaxed text-foreground-600 md:text-sm">
              {topic.description}
            </p>
            <span className="mt-3 flex items-center gap-1 text-xs font-medium text-primary-600">
              进入专题
              <i className="ri-arrow-right-line"></i>
            </span>
          </div>
        </Link>
      ))}
    </div>
  );
}